import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenu, renderContextMenuItems } from "@air/primitive-context-menu";
import { tailwindMerge } from "@air/tailwind-variants";
import { useState } from "react";
import { ContentCollectionGalleryAssetButton } from "~/components/ContentCollection/ContentCollectionGalleryAssetButton";
import { useSelectableCard } from "~/hooks/useSelectableCard";
import { useSelectionAwareContextMenuOptions } from "~/hooks/useSelectionAwareContextMenuOptions";
export const ContentCollectionGalleryAssetCard = (param)=>{
    let { className, children, getItemMenuOptions, getSelectionMenuOptions, isSelectable, isInvalid, item, onClick } = param;
    const { onBlur, onFocus, handleHover, isHovering, handleItemClick, handleItemDoubleClick, handleUnhover, confirmItemSelection, preSelectItem, itemRef, isSelected, isHighlighted } = useSelectableCard({
        item,
        onClick,
        isSelectable
    });
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const contextMenuOptions = getItemMenuOptions({
        trackLocation: "gallery-item-context-menu"
    });
    const { options } = useSelectionAwareContextMenuOptions({
        contextMenuOptions,
        id: item.id,
        selectionMenuOptions: getSelectionMenuOptions("gallery-multi-select-context-menu")
    });
    return /*#__PURE__*/ _jsx(ContextMenu, {
        trigger: /*#__PURE__*/ _jsxs("div", {
            className: tailwindMerge("flex size-full flex-col gap-2 rounded-lg bg-grey-1 p-2 shadow-kanban", (isSelected || isHighlighted) && "ring-2 ring-blue-9", isInvalid && "ring-2 ring-red-9", className),
            onBlur: onBlur,
            onFocus: onFocus,
            onMouseEnter: handleHover,
            onMouseLeave: handleUnhover,
            ref: itemRef,
            children: [
                /*#__PURE__*/ _jsx(ContentCollectionGalleryAssetButton, {
                    confirmItemSelection: confirmItemSelection,
                    isSelectable: isSelectable,
                    onClick: onClick,
                    preSelectItem: preSelectItem
                }),
                children({
                    onBlur,
                    onFocus,
                    handleHover,
                    isHovering: isHovering || isMenuOpen,
                    handleItemClick,
                    handleItemDoubleClick,
                    handleUnhover,
                    confirmItemSelection,
                    preSelectItem,
                    itemRef,
                    isSelected,
                    isHighlighted,
                    setIsMenuOpen,
                    isMenuOpen
                })
            ]
        }),
        children: renderContextMenuItems({
            options
        })
    });
};
